// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expandableSection {
  position: relative;
  margin: auto;
  max-width: unset;
}
.expandableSection > .k-form,
.expandableSection > section {
  max-width: unset;
}
.expandableSection > div {
  padding: 0;
  overflow: hidden;
  margin-bottom: 24px;
  margin-top: 24px;
}
.expandableSection h2 {
  font-size: 28px;
  font-weight: bold;
  line-height: 32px;
  text-align: center;
  margin: 25px auto;
  color: #262626;
}
.expandableSection .topBorderDivider {
  margin-bottom: 24px;
}
.expandableSection .topBorderDivider > section {
  margin-top: 24px;
}
.expandableSection .expandOrCollapseButton {
  position: absolute;
  right: 0;
  top: 0;
  background: #ededed;
  color: #262626;
  border: 1px solid rgba(38, 38, 38, 0.3);
  border-radius: 8px;
  height: 30px;
  width: 30px;
  margin: 0;
  padding: 0;
}
`, "",{"version":3,"sources":["webpack://./src/commonComponents/fields/SubSection.less"],"names":[],"mappings":"AAAA;EACC,kBAAA;EACA,YAAA;EACA,gBAAA;AACD;AAJA;;EAOE,gBAAA;AACF;AARA;EAYE,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AADF;AAdA;EAoBE,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AAHF;AAtBA;EA6BE,mBAAA;AAJF;AAzBA;EA+BG,gBAAA;AAHH;AA5BA;EAoCE,kBAAA;EACA,QAAA;EACA,MAAA;EACA,mBAAA;EACA,cAAA;EACA,uCAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AALF","sourcesContent":[".expandableSection {\n\tposition: relative;\n\tmargin: auto;\n\tmax-width: unset;\n\n\t> .k-form,\n\t> section {\n\t\tmax-width: unset;\n\t}\n\n\t> div {\n\t\t// this could be section\n\t\tpadding: 0;\n\t\toverflow: hidden;\n\t\tmargin-bottom: 24px;\n\t\tmargin-top: 24px;\n\t}\n\n\th2 {\n\t\t//color: @nightBlue;\n\t\tfont-size: 28px;\n\t\tfont-weight: bold;\n\t\tline-height: 32px;\n\t\ttext-align: center;\n\t\tmargin: 25px auto;\n\t\tcolor: #262626;\n\t}\n\n\t.topBorderDivider {\n\t\tmargin-bottom: 24px;\n\t\t> section {\n\t\t\tmargin-top: 24px;\n\t\t}\n\t}\n\n\t.expandOrCollapseButton {\n\t\tposition: absolute;\n\t\tright: 0;\n\t\ttop: 0;\n\t\tbackground: #ededed;\n\t\tcolor: #262626;\n\t\tborder: 1px solid rgba(38, 38, 38, 0.3);\n\t\tborder-radius: 8px;\n\t\theight: 30px;\n\t\twidth: 30px;\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
